/**
 * Ypersoa — Réinitialisation perso
 * Ajoute un bouton "Réinitialiser" dans chaque header .yp-perso-premium
 * avec confirmation modale avant reset complet.
 */
(function () {
  'use strict';

  const RESET_ICON = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 0 1 9-9 9 9 0 0 1 6.4 2.6L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-9 9 9 9 0 0 1-6.4-2.6L3 16"/><path d="M3 21v-5h5"/></svg>';

  function injectResetButton(header) {
    if (header.querySelector('.yp-perso-reset')) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'yp-perso-reset';
    btn.setAttribute('aria-label', 'Réinitialiser ma personnalisation');
    btn.innerHTML = RESET_ICON + '<span>Réinitialiser</span>';
    header.appendChild(btn);
    btn.addEventListener('click', function () {
      openResetModal(header.closest('.yp-perso-premium'));
    });
  }

  function resetPersoBlock(block) {
    if (!block) return;
    const content = block.querySelector('.yp-perso-premium__content');
    if (!content) return;

    content.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], input[type="number"], input:not([type]), textarea').forEach((el) => {
      el.value = '';
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    });

    content.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach((el) => {
      const wasChecked = el.checked;
      if (el.hasAttribute('data-default-checked')) {
        el.checked = el.getAttribute('data-default-checked') === 'true';
      } else {
        el.checked = el.defaultChecked;
      }
      if (wasChecked !== el.checked) el.dispatchEvent(new Event('change', { bubbles: true }));
    });

    content.querySelectorAll('select').forEach((el) => {
      el.selectedIndex = 0;
      el.dispatchEvent(new Event('change', { bubbles: true }));
    });

    content.querySelectorAll('.yp-counter').forEach((el) => {
      const match = el.textContent.match(/\/(\d+)/);
      el.textContent = match ? '0/' + match[1] : '0';
    });

    content.querySelectorAll('.yp-stepper__step').forEach((step, i) => {
      step.classList.toggle('active', i === 0);
    });
    const bar = content.querySelector('#yp-bar, .yp-stepper__bar');
    if (bar) bar.style.width = '33%';
    content.querySelectorAll('.step-label').forEach((label, i) => {
      label.classList.toggle('active', i === 0);
    });
    const prevBtn = content.querySelector('#yp-prev, .yp-prev');
    const nextBtn = content.querySelector('#yp-next, .yp-next');
    if (prevBtn) prevBtn.style.display = 'none';
    if (nextBtn) nextBtn.style.display = '';

    content.dispatchEvent(new CustomEvent('yp-perso:reset', { bubbles: true }));
  }

  let currentModal = null;
  function openResetModal(block) {
    closeResetModal();
    const modal = document.createElement('div');
    modal.className = 'yp-perso-reset-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'yp-reset-title');
    modal.innerHTML = [
      '<div class="yp-perso-reset-modal__backdrop"></div>',
      '<div class="yp-perso-reset-modal__dialog">',
      '  <h2 id="yp-reset-title" class="yp-perso-reset-modal__title">Effacer ta personnalisation ?</h2>',
      '  <p class="yp-perso-reset-modal__text">Tout ce que tu as saisi (texte, couleurs, motifs, options) sera remis à zéro. La taille et la couleur du produit sont conservées.</p>',
      '  <div class="yp-perso-reset-modal__actions">',
      '    <button type="button" class="yp-perso-reset-modal__cancel">Annuler</button>',
      '    <button type="button" class="yp-perso-reset-modal__confirm">Oui, tout effacer</button>',
      '  </div>',
      '</div>'
    ].join('');
    document.body.appendChild(modal);
    currentModal = modal;
    document.body.style.overflow = 'hidden';

    requestAnimationFrame(() => modal.classList.add('is-open'));

    modal.querySelector('.yp-perso-reset-modal__cancel').addEventListener('click', closeResetModal);
    modal.querySelector('.yp-perso-reset-modal__backdrop').addEventListener('click', closeResetModal);
    modal.querySelector('.yp-perso-reset-modal__confirm').addEventListener('click', function () {
      resetPersoBlock(block);
      closeResetModal();
    });
    document.addEventListener('keydown', escHandler);

    const confirmBtn = modal.querySelector('.yp-perso-reset-modal__confirm');
    if (confirmBtn) confirmBtn.focus();
  }

  function closeResetModal() {
    if (!currentModal) return;
    currentModal.classList.remove('is-open');
    const m = currentModal;
    currentModal = null;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', escHandler);
    setTimeout(() => { if (m.parentNode) m.parentNode.removeChild(m); }, 200);
  }

  function escHandler(e) {
    if (e.key === 'Escape') closeResetModal();
  }

  function init() {
    document.querySelectorAll('.yp-perso-premium__header').forEach(injectResetButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
